<div class="relative">
  <div [ngClass]="disabled? 'flex flex-row disabled-input': 'flex flex-row input'" (blur)="inputIsFocused = false">
    <input
      [disabled]="disabled"
      (change)="searchFilterChange.emit(searchFilter)"
      (input)="search(searchFilter)"
      [(ngModel)]="searchFilter"
      [placeholder]="placeholder"
      [ngClass]="disabled? 'inner-disabled-input flex-grow': 'inner-input flex-grow'"
      (focus)="inputIsFocused = true"
      />
      <div [ngClass]="disabled? 'vertical-disabled-line': 'vertical-line'"></div>
      <button aria-label="Open Dropdown Search" [disabled]="disabled" (click)="inputIsFocused = !inputIsFocused" class="px-1">
        @if (!inputIsFocused) {
          <fa-icon [icon]="faChevronDown" />
        }
        @if (inputIsFocused) {
          <fa-icon [icon]="faChevronUp" />
        }
      </button>
    </div>
    @if (inputIsFocused) {
      <div class="dropdown shadow w-full flex flex-col overflow-y-auto">
        @for (item of filteredItems; track item) {
          <div class="flex flex-row hover:bg-gray-200 rounded-[8px]">
            @if (!findItemInAddedItems(item)) {
              <button (click)="select(item)" class="p-1 flex-grow text-left">
                @if (isSubject) {
                  <p>{{item.subject_name}}</p>
                }
                @if (isUnit) {
                  <p>{{item.unit_name}}</p>
                }
                @if (isOrganization) {
                  <p>{{item.organization_name}}</p>
                }
                @if (isCourse) {
                  <p>{{item.course_name}}</p>
                }
                {{item.name}}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
